import React from "react";

interface CandidateDetailsProps {
  addressInfo?: any;
}

const CandidateDetails: React.FC<CandidateDetailsProps> = ({ addressInfo }) => {
  return (
    <>
      {/* =============== Candidate Details =============== */}

      <div className="card mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0 fw-semibold">Address Information</h5>
        </div>

        <div className="card-body p-0">
          {/* Responsive Table Wrapper */}
          <div className="table-responsive">
            <table
              className="table table-bordered align-middle mb-0"
              style={{ minWidth: "650px" }}
            >
              <tbody>
                <tr>
                  <th style={{ width: "25%" }}>Address Type</th>
                  <td colSpan={3}>{addressInfo?.address_type || "-"}</td>
                </tr>

                <tr>
                  <th>Pincode</th>
                  <td>{addressInfo?.pincode || "-"}</td>

                  <th>City</th>
                  <td>{addressInfo?.city || "-"}</td>
                </tr>

                <tr>
                  <th>State</th>
                  <td>{addressInfo?.state || "-"}</td>

                  <th>Country</th>
                  <td>{addressInfo?.country || "-"}</td>
                </tr>

                <tr>
                  <th>Complete Address</th>
                  <td colSpan={3}>{addressInfo?.address_line1 || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateDetails;
